import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { LinkComponent } from '@rsos/components/capstone/base';

export const PoweredByHarmonyContainer = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  width: '100%',
})``;

export const TitleBox = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  flow: 4,
})``;

export const TitleText = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
  fontWeight: 'bold',
})``;

export const PopoverBox = styled(Box).attrs({
  width: '267px',
  padding: '10px',
  backgroundColor: 'primaryText',
  borderRadius: '5px',
})``;

export const PopoverText = styled(Text).attrs({
  color: 'background',
  size: 'small',
})``;

export const HarmonyBox = styled(Box).attrs({
  horizontal: true,
  flow: 4,
  align: 'center',
})``;

export const HarmonyText = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;

export const HarmonyLink = styled(LinkComponent).attrs({
  type: 'secondary',
  noPadding: true,
})`
  &:hover {
    color: ${({ theme }) => theme.colors.secondaryText};
    text-decoration: underline;
  }
`;
